import { userIsPremium } from '../../../utils/user.js';
import { AbstractService } from './AbstractService.js';

/**
 * @typedef {import('poool-engage').Poool.EngageConfigOptions} EngageServiceConfig
 */

/**
 * EngageService class.
 * @augments {AbstractService<EngageServiceConfig>}
 */
export default class EngageService extends AbstractService {
  /**
   * @type {EngageServiceConfig}
   */
  static config = {
    debug: false,
    autoPageViews: true,
    stripePublicKey: null,
    locale: 'en',
    pianoAutoTrackingEnabled: false,
    gtagAutoTrackingEnabled: false,
  };

  static script = 'https://assets.poool.fr/engage.min.js';

  /**
   * @type {import('poool-engage').Poool.Engage|null}
   */
  engage = null;

  /**
   * Initialize service.
   * @returns {Promise<void>}
   */
  async init() {
    const { Engage } = window;

    if (this.engage || !Engage) {
      return;
    }

    this.engage = Engage.init(this.appId);
    this.engage.config(this.config);
    this.engage.config('locale', 'fr');
    this.engage.autoCreate({
      filters: [userIsPremium() ? 'user_subscribed' : 'user_unsubscribed'],
    });

    window.dispatchEvent(new CustomEvent('poool:engage:ready', { detail: this }));
  }

  /**
   * Run service.
   * @returns {void}
   */
  run() {
    this.load();
  }
}
